import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {LoginViewComponent} from './_shared/login-view/login-view.component';
import {AuthGuard} from './_shared/guards/authentication-guard';
import {MyAccountViewComponent} from './_shared/my-account-view/my-account-view.component';
import {NotAuthGuard} from './_shared/guards/not-authentication-guard';
import {FoldersViewComponent} from './folder/folders-view/folders-view.component';

const routes: Routes = [
    {path: 'ingresar', component: LoginViewComponent, canActivate: [NotAuthGuard]},
    {path: 'mi-cuenta', component: MyAccountViewComponent, canActivate: [AuthGuard]},
    {path: 'carpetas', component: FoldersViewComponent, canActivate: [AuthGuard]},
    {path: 'carpetas/:id', component: FoldersViewComponent, canActivate: [AuthGuard]},
    {path: 'inicio', redirectTo: 'carpetas', pathMatch: 'full', canActivate: [AuthGuard]},
    {path: '', redirectTo: 'carpetas', pathMatch: 'full'},
    {path: '**', redirectTo: 'carpetas', pathMatch: 'full'}
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule]
})
export class AppRoutingModule {
}



// WEBPACK FOOTER //
// ./src/app/app-routing.module.ts